import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { TextMasks } from './business-information/business-validators';

@Directive({
  selector: '[appInputMask]',
  standalone: true,
})
export class InputMaskDirective implements OnInit {
  @Input('appInputMask') maskType: keyof TextMasks;

  private masks = new TextMasks();
  private currentMask: (RegExp | string)[] = [];

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    if (this.maskType && this.masks[this.maskType]) {
      this.currentMask = this.masks[this.maskType];
    } else {
      console.error(`Mask type '${this.maskType}' not found.`);
    }

  }

  @HostListener('input', ['$event'])
  onInput(): void {
    console.log('onInput triggered');
    const inputEl = this.el.nativeElement;
    const rawValue = inputEl.value.replace(/\D/g, '');

    const masked = this.applyMask(rawValue, this.currentMask);

    // Set formatted value to the input element
    const prevCursor = inputEl.selectionStart ?? masked.length;

    this.renderer.setProperty(inputEl, 'value', masked);

    // Sync with form control
    if (this.control?.control) {
      this.control.control.setValue(masked, { emitEvent: false });
    }
  }

  private applyMask(value: string, mask: (RegExp | string)[]): string {
    let result = '';
    let valueIndex = 0;

    for (let i = 0; i < mask.length; i++) {
      const m = mask[i];

      if (typeof m === 'string') {
        result += m;
      } else if (valueIndex < value.length && m.test(value[valueIndex])) {
        result += value[valueIndex];
        valueIndex++;
      } else {
        break;
      }
    }

    return result;
  }

}
